// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"27f8fdb8","286":"b39777e2","500":"f8b6606b","739":"00b74268","754":"39af2d68","759":"d287daea","853":"bb5fd824","979":"220fabba"}[chunkId] + ".chunk.js";
};